import { render, staticRenderFns } from "./DefaultBurgerMenu.vue?vue&type=template&id=6525d3b9&scoped=true&"
import script from "./DefaultBurgerMenu.vue?vue&type=script&lang=js&"
export * from "./DefaultBurgerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6525d3b9",
  null
  
)

export default component.exports